module.exports = __webpack_public_path__ + "static/logo-4fe6b52d9cec0f7937e0bda754114514.png";